export var MENTION_PROVIDER_REJECTED = 'REJECTED';
export var MENTION_PROVIDER_UNDEFINED = 'UNDEFINED';

/**
 * @private
 * @deprecated Use {@link MentionsPluginOptions} instead.
 * @see https://product-fabric.atlassian.net/browse/ED-27496
 */